import React from 'react';
import PropTypes from 'prop-types';


import Button from 'Components/Button';

const HollowButton = ({
  children,
  ...props
}) => {
	//This change is for white labeling for HPY
   const acquirer = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode == 'HPY' ? 
		JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode : 'GPN';
  return (
    <Button
      category={`hollow${acquirer}`}
      {...props}
    >
      {children}
    </Button>
  );
};

HollowButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export default HollowButton;
